import { frontalQuad } from '../geometry';
import type { Camera } from '../geometry';
import type { SceneRegion } from './types';

/**
 * Wall — a living-room feature wall: a full-height stone panel with a lit niche and a floating
 * console below, seen straight on from the sofa. Metres; the camera stands 0.9 m in front of the frame.
 */
export const wallCamera: Camera = { eye: [0, 1.45, -0.9], focal: 900, center: [600, 383] };

export const WALL = {
  /** Depth of the stone wall. */
  z: 4.2,
  half: 2.2,
  height: 2.9,
  /** The niche cut into the stone. */
  niche: { x0: -1.5, x1: 1.5, y0: 1.0, y1: 1.72, depth: 0.5 },
} as const;

export const wallRegions: readonly SceneRegion[] = [
  {
    id: 'panel',
    quad: frontalQuad(wallCamera, -WALL.half, WALL.half, 0, WALL.height, WALL.z),
    size: [2 * WALL.half, WALL.height],
    tile: 1.1,
    bleed: 0.8,
  },
];
